export default {
    baseUrl: 'https://webapi.aamuyeed.com/',
    baseUrlLive: 'https://webapi.aamuyeed.com/'
};
  